"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Invite;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var writing = false;
function Invite() {
    var mainRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        var _a;
        if (((_a = mainRef.current) === null || _a === void 0 ? void 0 : _a.innerText) === "" && !writing) {
            writing = true;
            var text_1 = "E\u00A0aí,\u00A0bora\u00A0cultivar?";
            var timer = 120;
            var parts_1 = text_1.split("");
            var timelimit = parts_1.length * timer * 1.5;
            var acc_1 = 0;
            var interv_1 = setInterval(function () {
                if (mainRef.current &&
                    mainRef.current.innerText.length < parts_1.length &&
                    acc_1 < parts_1.length &&
                    !mainRef.current.innerText.endsWith("?")) {
                    mainRef.current.innerText += parts_1[acc_1] === " " ? " " : parts_1[acc_1];
                    acc_1++;
                }
            }, timer);
            setTimeout(function () {
                clearInterval(interv_1);
                if (mainRef.current)
                    mainRef.current.innerText = text_1;
            }, timelimit);
        }
    }, [mainRef]);
    return (0, jsx_runtime_1.jsx)("strong", { ref: mainRef, id: "invite-logo-title" });
}
